// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"p9-z"};